"use client";

import { saveAs } from "file-saver";
import { useTranslations } from "next-intl";
import { BsDownload } from "react-icons/bs";
import { generateIcon } from "utils";
import type { PhotoItemType, VideoItemType } from "./types";

interface IMediaDownloadButtonProps {
  item: VideoItemType | PhotoItemType;
  className?: string;
}

/**
 * Per-item download button shown on the gallery thumbnail.
 *
 * Saving one file straight from the tap keeps it inside the user gesture,
 * which is the only way iOS lets a file through. It is also the only way to
 * pick individual files there, since several separate downloads in a row are
 * refused by the browser.
 */
export default function MediaDownloadButton({
  item,
  className = "top-1 right-1",
}: IMediaDownloadButtonProps) {
  const t = useTranslations();

  if (!item.url) return null;

  return (
    <button
      type="button"
      aria-label={t("Gallery.downloadItem")}
      title={t("Gallery.downloadItem")}
      className={`absolute z-40 bg-black/60 hover:bg-black/80 text-white rounded p-[6px] pointer-events-auto ${className}`}
      onClick={(e) => {
        // The thumbnail itself opens the lightbox.
        e.stopPropagation();
        e.preventDefault();
        saveAs(item.url, item.name);
      }}
    >
      {generateIcon(BsDownload, "h-[16px] w-[16px]")}
    </button>
  );
}
